import * as moment from "moment";

export interface IBonusDetail {
  id: number;
  billing_tin: string;
  location_name: string | null;
  npi: string;
  provider_name: string | null;
  member_plan_id: string;
  somos_member_id: string | null;
  display_name: string | null;
  dob?: moment.Moment | null;
  gender: string | null;
  mco_id: number;
  mco: string;
  owner_id: string | null;
  raw_measure: string;
  numerator: string;
  denominator: number;
  ipa: string;
  earnings: number;
  potential: number;
  reporting_period: number;
  event_date?: moment.Moment | null;
  due_date?: moment.Moment | null;
  gic_id: string;
  measure_id: string;
  measure_code:string |null;
}

export class BonusDetail implements IBonusDetail {
  id: number;
  billing_tin: string;
  location_name: string | null;
  npi: string;
  provider_name: string | null;
  member_plan_id: string;
  somos_member_id: string | null;
  display_name: string | null;
  dob?: moment.Moment | null;
  gender: string | null;
  mco_id: number;
  mco: string;
  owner_id: string | null;
  raw_measure: string;
  numerator: string;
  denominator: number;
  ipa: string;
  earnings: number;
  potential: number;
  reporting_period: number;
  event_date?: moment.Moment | null;
  due_date?: moment.Moment | null;
  gic_id: string;
  measure_id: string;
  measure_code:string |null;

  constructor(data: IBonusDetail) {
    Object.assign(this, data);
  }

  static fromObject(data: IBonusDetail): BonusDetail {
    return new BonusDetail(data);
  }

  static fromObjectArray(data: IBonusDetail[]): BonusDetail[] {
    return data.map(BonusDetail.fromObject);
  }
}

export interface IResultBonusDetail {
  count: number;
  next: string | null;
  previous: string | null;
  results: IBonusDetail[];
}

export class ResultBonusDetail implements IResultBonusDetail {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: BonusDetail[] = [];

  constructor(data?: IResultBonusDetail) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = BonusDetail.fromObjectArray(data.results);
    }
  }

  static fromObject(data: IResultBonusDetail): ResultBonusDetail {
    return new ResultBonusDetail(data);
  }
}
